(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class UtilityBar extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.announcement = this.closest('.announcement-bar-section');
      this.announcementBounds = {};

      this.setAnnouncementHeight();

      window.addEventListener('resize', this.setAnnouncementHeight.bind(this));

      this.createObserver();
    }

    setAnnouncementHeight(mediaQuery) {
      document.documentElement.style.setProperty('--announcement-height', `${this.announcement.offsetHeight}px`);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.announcementBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.announcement);
    }
  }

  customElements.define('utility-bar', UtilityBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["banner-atf-3"] && !Shopify.designMode) return;
  try {
    
  class ATFslider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.sliderWrapper = this.querySelector('.swiper');
      this.initialSlideIndex = Number(this.dataset.initialSlideIndex || 0)
      this.init();
    }

    init() {
      if (!this.sliderWrapper) return;

      this.slider = new Swiper(this.sliderWrapper, {
        grabCursor: true,
        loop: false,
        slidesPerView: 'auto',
        spaceBetween: 16,
        navigation: {
          nextEl: this.querySelector('.swiper-button-next'),
          prevEl: this.querySelector('.swiper-button-prev'),
        }
      });
    }
  }

  customElements.define('atf-slider', ATFslider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["banner-atf"] && !Shopify.designMode) return;
  try {
    
  class ATFslider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.sliderWrapper = this.querySelector('.swiper');
      this.initialSlideIndex = Number(this.dataset.initialSlideIndex || 0)
      this.init();
    }

    init() {
      if (!this.sliderWrapper) return;

      this.slider = new Swiper(this.sliderWrapper, {
        grabCursor: true,
        loop: false,
        slidesPerView: 'auto',
        spaceBetween: 16,
        navigation: {
          nextEl: this.querySelector('.swiper-button-next'),
          prevEl: this.querySelector('.swiper-button-prev'),
        }
      });
    }
  }

  customElements.define('atf-slider', ATFslider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cookie-bar"] && !Shopify.designMode) return;
  try {
    
  class CookieBar extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.close = this.querySelector('button');
      this.checkAcceptance();

      this.close.addEventListener('click', this.handleCloseClick.bind(this));
    }

    checkAcceptance() {
      if (!getCookie('cookies_policy')) {
        this.classList.remove('hidden');
      }
    }

    handleCloseClick() {
      setCookie('cookies_policy', 'true', 365);
      this.classList.add('hidden');
    }
  }

  customElements.define('cookie-bar', CookieBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
  class FeaturedCards extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.controls = this.querySelectorAll(
        '[data-controls-prev], [data-controls-next]'
      );
      this.slider = new Swiper(this.querySelector('.swiper'), {
        slidesPerView: 'auto',
        spaceBetween: 16,
        breakpoints: {
          990: {
            slidesPerView: 3,
            spaceBetween: 24,
          },
          1200: {
            slidesPerView: Number(this.dataset.count),
          }
        }
      });
      this.controls.forEach((control) =>
        control.addEventListener('click', this.handleOnControlClick.bind(this))
      );
    }

    handleOnControlClick(event) {
      if (!this.slider) return;

      this.slider[
        event.target.hasAttribute('data-controls-prev')
          ? 'slidePrev'
          : 'slideNext'
      ]();
    }
  }

  customElements.define('featured-cards', FeaturedCards);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-videos"] && !Shopify.designMode) return;
  try {
    
  class FeaturedVideos extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.sliderWrapper = this.querySelector('.swiper');
      this.initialSlideIndex = Number(this.dataset.initialSlideIndex || 0)
      this.init();
    }

    init() {
      if (!this.sliderWrapper) return;

      this.slider = new Swiper(this.sliderWrapper, {
        effect: "coverflow",
        grabCursor: true,
        centeredSlides: true,
        loop: true,
        slidesPerView: 'auto',
        spaceBetween: 32,
        coverflowEffect: {
          rotate: 0,
          scale: 1,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: false,
        },
        navigation: {
          nextEl: this.querySelector('.swiper-button-next'),
          prevEl: this.querySelector('.swiper-button-prev'),
        },
        breakpoints: {
          750: {
            spaceBetween: 48
          },
          990: {
            spaceBetween: 16,
            coverflowEffect: false
          }
        }
      });

      this.slider.on('beforeSlideChangeStart', function () {
        window.pauseAllMedia();
      });
    }
  }

  customElements.define('featured-videos', FeaturedVideos);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = this.closest('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight(mediaQuery) {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('predictive-search');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-reviews"] && !Shopify.designMode) return;
  try {
    
  class HeroReviews extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.slider = new Swiper(this.querySelector('.swiper'), {
        slidesPerView: 'auto',
        spaceBetween: 16,
        breakpoints: {
          990: {
            slidesPerView: 6
          },
        }
      });
    }
  }

  customElements.define('hero-reviews', HeroReviews);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"] && !Shopify.designMode) return;
  try {
    
  class MainArticle extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.navActiveIndex = 0;
      this.sections = this.querySelectorAll("[data-section]");
      this.navLinks = this.querySelectorAll("[data-nav-link]");
      this.mobileNavLinks = this.querySelectorAll("[data-nav-link-mobile]");
      window.addEventListener("scroll", this.handleScrollSpy.bind(this));
    }

    toggleActiveLink(link, flag = false) {
      if (!this.navLinks[link]) return;
      return this.navLinks[link].classList.toggle("is-active", flag);
    }

    unsetAllActiveLinks() {
      return [...Array(this.sections.length).keys()].forEach((link) =>
        this.toggleActiveLink(link)
      );
    }

    handleScrollSpy() {
      const sectionMargin = 200;
      const current =
        this.sections.length -
        [...this.sections]
          .reverse()
          .findIndex(
            (section) => window.scrollY >= section.offsetTop - sectionMargin
          ) -
        1;
      const currentSectionIndex = current + 1;

      if (current !== this.sectionActiveIndex) {
        this.unsetAllActiveLinks();
        this.sectionActiveIndex = current;
        this.toggleActiveLink(current, true);
      }

      this.setProgress(
        currentSectionIndex > this.sections.length ? 0 : currentSectionIndex
      );
    }

    setProgress(index) {
      const progressPercentage = (index / this.sections.length) * 100;
      this.style.setProperty(
        "--article-content-progress",
        `${progressPercentage}%`
      );
    }
  }

  customElements.define("main-article", MainArticle);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog-articles"] && !Shopify.designMode) return;
  try {
    
  class BlogFeaturedArticles extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.slider = new Swiper(this.querySelector('.swiper'), {
        spaceBetween: 16,
        slidesPerView: 'auto',
        grabCursor: true,
      });
    }
  }

  customElements.define('blog-featured-articles', BlogFeaturedArticles);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  class VideoReviewsSlider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.sliderWrapper = this.querySelector('.swiper');
      this.initialSlideIndex = Number(this.dataset.initialSlideIndex || 0)
      this.activeSlide = null;
      this.init();
    }

    async init() {
      this.initSlider();

      this.addEventListener('click', (event) => {
        const videos = this.querySelectorAll('card-video video');

        videos.forEach((video) => {
          const closestVideo = event.target.closest('video');
          if (closestVideo && closestVideo != video) {
            if (!video.paused) video.pause();
          }
        });
      });
    }

    isFullyInViewport() {
      const rect = this.sliderWrapper.getBoundingClientRect();

      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= window.innerHeight &&
        rect.right <= window.innerWidth
      );
    }

    autoplayWhenInView() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const activeSlideCardVideo = this.activeSlide?.querySelector('card-video');
          const activeSlideVideo = activeSlideCardVideo.querySelector('video');
          const hasInitializedVideo = activeSlideCardVideo.getAttribute('loaded');

          if (entry.isIntersecting) {
            if (!hasInitializedVideo) {
              if (document.documentElement.classList.contains('user-has-interacted')) {
                activeSlideVideo.dispatchEvent(new CustomEvent('init'));
              }
            } else {
              if (activeSlideVideo.paused && !this.classList.contains('prevent-inview-autoplay')) {
                activeSlideVideo.play();
              }
            }
          } else {
            if (hasInitializedVideo) {
              this.sliderWrapper.querySelectorAll('card-video video').forEach((video) => {
                if (!video.paused) video.pause();
              });
            }
          }
        });
      }, {
        threshold: 0.5
      });

      observer.observe(this.sliderWrapper);
    }

    autoplayVideoInActiveSlide() {
      const hasInitializedVideo = this.activeSlide.querySelector('card-video').getAttribute('loaded');
      if (!hasInitializedVideo) {
        this.activeSlide.querySelector('card-video').dispatchEvent(new CustomEvent('init'));
      } else {
        this.activeSlide.querySelector('card-video video').dispatchEvent(new CustomEvent('play'));
      }
    }

    initSlider() {
      if (!this.sliderWrapper) return;

      const _this = this;

      this.slider = new Swiper(this.sliderWrapper, {
        effect: "coverflow",
        grabCursor: true,
        slidesPerView: 'auto',
        coverflowEffect: false,
        spaceBetween: 12,
        navigation: {
          nextEl: this.querySelector('.swiper-button-next'),
          prevEl: this.querySelector('.swiper-button-prev'),
        },
        breakpoints: {
          990: {
            spaceBetween: 20
          }
        },
        on: {
          click(swiper, event) {
            requestAnimationFrame(() => {
              const clickedVideo = event.target.closest('card-video').querySelector('video');
              if (clickedVideo.paused) {
                _this.classList.add('prevent-inview-autoplay');
              } else {
                _this.classList.remove('prevent-inview-autoplay');
              }
            });
          },
          afterInit(swiper) {
            _this.activeSlide = swiper.slides[swiper.activeIndex];
            _this.autoplayWhenInView();
          },
          slideChange(swiper) {
            _this.activeSlide = swiper.slides[swiper.activeIndex];
            _this.autoplayVideoInActiveSlide();
          }
        }
      });

      this.slider.on('beforeSlideChangeStart', function () {
        window.pauseAllMedia();
      });
    }
  }

  customElements.define('video-reviews-slider', VideoReviewsSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-articles"] && !Shopify.designMode) return;
  try {
    
  class RelatedArticles extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.slider = new Swiper(this.querySelector('.swiper'), {
        slidesPerView: 'auto',
        spaceBetween: 16,
        breakpoints: {
          990: {
            slidesPerView: 2,
            spaceBetween: 32,
          }
        }
      });
    }
  }

  customElements.define('related-articles', RelatedArticles);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
  class ReviewsGrid extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.reviewsGrid = this.querySelector('[data-reviews-grid]');
      this.buttonsToggleVisible = this.querySelectorAll('[data-toggle-visible]');
      this.buttonsToggleVisible.forEach((button) => {
        button.addEventListener('click', () => {
          if (!this.reviewsGrid) return;

          if (button.hasAttribute('data-scroll-back')) {
            this.reviewsGrid.scrollIntoView({ block: 'start', behavior: 'smooth' });
          }

          this.reviewsGrid.classList.toggle('is-visible');
        });
      });
    }
  }

  customElements.define('reviews-grid', ReviewsGrid);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-with-cards-carousel"] && !Shopify.designMode) return;
  try {
    
  class TextWithCardsCarousel extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.cardsGrid = this.querySelector('[data-cards-grid]');
      this.buttonsToggleVisible = this.querySelectorAll('[data-toggle-visible]');
      this.sliderWrapper = this.querySelector('.swiper');
      this.init();
      this.controls = this.querySelectorAll(
        '[data-controls-prev], [data-controls-next]'
      );
      this.controls.forEach((control) =>
        control.addEventListener('click', this.handleOnControlClick.bind(this))
      );
      this.buttonsToggleVisible.forEach((button) => {
        button.addEventListener('click', () => {
          if (!this.cardsGrid) return;

          if (button.hasAttribute('data-scroll-back')) {
            this.cardsGrid.scrollIntoView({ block: 'start', behavior: 'smooth' });
          }

          this.cardsGrid.classList.toggle('is-visible');
        });
      });
    }

    init() {
      if (!this.sliderWrapper) return;

      this.slider = new Swiper(this.sliderWrapper, {
        slidesPerView: 1,
        spaceBetween: 16,
        autoHeight: true,
        breakpoints: {
          990: {
            slidesPerView: 'auto',
            autoHeight: false,
          }
        }
      });

      this.slider.on('beforeSlideChangeStart', function () {
        window.pauseAllMedia();
      });
    }

    handleOnControlClick(event) {
      if (!this.slider) return;

      this.slider[
        event.target.hasAttribute('data-controls-prev')
          ? 'slidePrev'
          : 'slideNext'
      ]();
    }
  }

  customElements.define('text-with-cards-carousel', TextWithCardsCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline-columns"] && !Shopify.designMode) return;
  try {
    
  class TimelineColumns extends HTMLElement {
    observer = undefined;

    constructor() {
      super();
    }

    connectedCallback() {
      this.attachHandlers();
    }

    attachHandlers() {
      this.observer?.unobserve(this);
      this.observer = new IntersectionObserver(
        (entries, observer) => {
          if (!entries[0].isIntersecting) return;

          observer.unobserve(this);

          this.classList.toggle(`animation-count-${Number(this.dataset.animationCount)}`, entries[0].isIntersecting);
        },
        {rootMargin: '0px 0px -600px 0px'}
      );
      this.observer.observe(this);
    }
  }

  customElements.define('timeline-columns', TimelineColumns);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-testimonials"] && !Shopify.designMode) return;
  try {
    
  class VideoTestimonials extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.sliderWrapper = this.querySelector('.swiper');
      this.init();
    }

    init() {
      if (!this.sliderWrapper) return;

      this.slider = new Swiper(this.sliderWrapper, {
        slidesPerView: 'auto',
        spaceBetween: 16,
        navigation: {
          nextEl: this.querySelector('.swiper-button-next'),
          prevEl: this.querySelector('.swiper-button-prev'),
        },
        breakpoints: {
          990: {
            spaceBetween: 24,
            slidesPerView: 3,
          }
        }
      });

      this.slider.on('beforeSlideChangeStart', function () {
        window.pauseAllMedia();
      });
    }
  }

  customElements.define('video-testimonials', VideoTestimonials);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["videos-grid"] && !Shopify.designMode) return;
  try {
    
  class VideosGrid extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.sliderWrapper = this.querySelector('.swiper');
      this.init();
    }

    init() {
      if (!this.sliderWrapper) return;

      this.slider = new Swiper(this.sliderWrapper, {
        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: 16,
        navigation: {
          nextEl: this.querySelector('.swiper-button-next'),
          prevEl: this.querySelector('.swiper-button-prev'),
        },
        breakpoints: {
          990: {
            slidesPerView: 4,
            centeredSlides: false,
          }
        }
      });

      this.slider.on('beforeSlideChangeStart', function () {
        window.pauseAllMedia();
      });
    }
  }

  customElements.define('videos-grid', VideosGrid);

  } catch(e) { console.error(e); }
})();
})();
